var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CpslTileButton } from '@usecapsule/react-components';
import { OAuthMethod } from '@usecapsule/web-sdk';
import { styled } from 'styled-components';
import { useCapsuleStore, useModalStore, useUserInfoStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { openPopup } from '../../utils/openPopup.js';
import { brandedOAuthLogos, oAuthLogos } from './config.js';
import { useThemeStore } from '../../stores/theme/useThemeStore.js';
import { Text } from '../common.js';
const HAS_MORE_LENGTH = 4;
export const OAuth = ({ methods }) => {
    const oAuthLogoVariant = useThemeStore(state => state.oAuthLogoVariant);
    const isDark = useThemeStore(state => state.isDark);
    const capsule = useCapsuleStore(state => state.capsule);
    const setFlow = useModalStore(state => state.setFlow);
    const setStep = useModalStore(state => state.setStep);
    const setEmail = useUserInfoStore(state => state.setEmail);
    const setWebAuthURLForLogin = useModalStore(state => state.setWebAuthURLForLogin);
    const setWebAuthURLForCreate = useModalStore(state => state.setWebAuthURLForCreate);
    const showAll = useModalStore(state => state.step === ModalStep.SIGN_UP_ALL_OAUTH);
    const hasMore = methods.length > HAS_MORE_LENGTH;
    const methodsToShow = showAll || !hasMore ? methods : methods.slice(0, HAS_MORE_LENGTH - 1);
    const handleShowAll = () => {
        setStep(ModalStep.SIGN_UP_ALL_OAUTH);
    };
    const handleMethodClick = (method) => () => __awaiter(void 0, void 0, void 0, function* () {
        if (method === OAuthMethod.FARCASTER) {
            setStep(ModalStep.FARCASTER_OAUTH);
            return;
        }
        setStep(ModalStep.AWAITING_OAUTH);
        const oAuthURL = yield capsule.getOAuthURL(method);
        openPopup(oAuthURL, `${method}AuthPopup`, 'OAUTH');
        const { email, userExists } = yield capsule.waitForOAuth();
        if (!email) {
            setStep(ModalStep.SIGN_UP);
            throw new Error('email is required');
        }
        setEmail(email);
        if (userExists) {
            const webAuthUrlForLogin = yield capsule.initiateUserLogin(email);
            setFlow('login');
            setWebAuthURLForLogin(webAuthUrlForLogin);
            setStep(ModalStep.BIOMETRIC_LOGIN);
        }
        else {
            const webAuthURLForCreate = yield capsule.getSetUpBiometricsURL(false);
            setFlow('signUp');
            setWebAuthURLForCreate(webAuthURLForCreate);
            setStep(ModalStep.BIOMETRIC_CREATION);
        }
    });
    const useBrandedLogos = oAuthLogoVariant === 'default';
    const useDarkLogos = useBrandedLogos ? isDark : oAuthLogoVariant !== 'dark';
    return (_jsxs(OAuthContainer, { children: [methodsToShow.map(method => (_jsx(StyledCpslTileButton, { "$isDark": useDarkLogos, icon: useBrandedLogos ? brandedOAuthLogos[method] : oAuthLogos[method], onClick: handleMethodClick(method), hasFullRow: methodsToShow.length >= 4 }, method))), !showAll && hasMore && (_jsx(MoreButton, { "$isDark": useDarkLogos, icon: "moreLoginOptions", onClick: handleShowAll, hasFullRow: true, children: _jsx(MoreText, { "$isDark": useDarkLogos, children: "MORE" }) }))] }));
};
const OAuthContainer = styled.div `
  display: flex;
  justify-content: center;
  gap: 4px;
  flex-wrap: wrap;
`;
const StyledCpslTileButton = styled(CpslTileButton) `
  flex: ${({ hasFullRow }) => (hasFullRow ? '0 0 calc(25% - 4px)' : '1')};

  --button-icon-color: ${({ $isDark }) => ($isDark ? 'white' : 'black')};
  --button-width: 100%;
`;
const MoreButton = styled(StyledCpslTileButton) `
  &::part(icon) {
    --height: 16px;
    --width: 16px;
  }
`;
const MoreText = styled(Text) `
  font-size: 8px;
  line-height: 8px;
  letter-spacing: 1px;
  color: ${({ $isDark }) => ($isDark ? 'white' : 'black')};
`;
